import { useDispatch, useSelector } from 'react-redux';

import {
  Sellers,
  Offices,
  CreateSellers,
  UpdateSellers,
  DeleteSellers,
} from '../../../store/actions';

/**
 * SellersInjections is responsible for injecting the data into the Accounts page.
 *
 * @return
 *
 */
export const SellersInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getSellers = async (filter) => {
    dispatch(Sellers(filter));
  };

  const getOffices = async () => {
    dispatch(Offices());
  };

  /**
   * @return Void
   */
  const deleteSellers = async (id) => {
    dispatch(DeleteSellers(id));
  };

  /**
   * @return void
   */
  const createSellers = async (data) => {
    dispatch(CreateSellers(data));
  };

  /**
   * @return void
   */
  const updateSellers = async (id, data) => {
    dispatch(UpdateSellers(id, data));
  };

  /**
   */

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   */
  const { sellers, success, offices, successOffices, error } = useSelector(
    (state) => ({
      error: state.Sellers.error,
      sellers: state.Sellers.sellers,
      success: state.Sellers.success,
      offices: state.Offices.offices,
      successOffices: state.Offices.success,
    })
  );

  return {
    getOffices,
    getSellers,
    createSellers,
    updateSellers,
    deleteSellers,
    error,
    offices,
    success,
    sellers,
    successOffices,
  };
};
